import { render, staticRenderFns } from "./JdDataTab.vue?vue&type=template&id=7902a578"
import script from "./JdDataTab.vue?vue&type=script&lang=js"
export * from "./JdDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports